import update from 'immutability-helper';
import {
	ON_SEARCH_CHANGE,
	ON_PAGE_CHANGE,
	SET_MOUSE_SIDE,
	SET_AUTO,
	SET_LAST_TAP,
	DEBUG_VAR
} from 'actions/UiActions';

export const INIT_UI_STATE = {
	searchText: "",
	page: 1,
	mouseSide: null,
	auto: false
}


export function uiReducer(state=INIT_UI_STATE, action){

	switch (action.type){

		case ON_SEARCH_CHANGE: {
			let {searchText} = action;
			return Object.assign(
				{},
				state,
				{searchText}
			);
		}

		case ON_PAGE_CHANGE: {
			let {page} = action;
			return Object.assign(
				{},
				state,
				{page}
			);
		}

		case SET_MOUSE_SIDE: {
			return Object.assign(
				{},
				state,
				{mouseSide: action.side}
			);
		}

		case SET_AUTO: {
			let {on} = action;
			return {
				...state,
				auto: on === null
					? !state.auto
					: on
			};
		}

		case DEBUG_VAR: {
			let {data} = action;
			return {
				...state,
				debugData: data
			};
		}

		default:
			return state;

	}
}
export default uiReducer;